import { FormGroup } from '@angular/forms';

// custom validator to check that two fields match
export function AccountLicenseCheck() {
    return (formGroup: FormGroup) => {
        if (formGroup.controls.licenseLimit2 && formGroup.controls.expertConcurrentLimit) {

            // return null if another validator has already found an error
            if (!(formGroup.controls.expertConcurrentLimit.errors && !formGroup.controls.expertConcurrentLimit.errors.concurrentExpertError)) {
                // set error if validation fails
                if (formGroup.controls.licenseLimit2.value > 0 && (formGroup.controls.expertConcurrentLimit.value === 0 || formGroup.controls.expertConcurrentLimit.value > formGroup.controls.licenseLimit2.value)) {
                    formGroup.controls.expertConcurrentLimit.setErrors({ concurrentExpertError: true });
                    formGroup.controls.expertConcurrentLimit.markAsTouched();
                } else {
                    formGroup.controls.expertConcurrentLimit.setErrors(null);
                }
            }
        }
        if (formGroup.controls.sessionexport && formGroup.controls.filesStoringDays) {
            if (!(formGroup.controls.sessionexport.errors && !formGroup.controls.sessionexport.errors.noFileStoring)) {
                if (formGroup.controls.filesStoringDays.value === -1 && formGroup.controls.sessionexport.value === true && formGroup.controls.webdav.value === false) {
                    formGroup.controls.sessionexport.setErrors({ noFileStoring: true });
                    formGroup.controls.sessionexport.markAsTouched();
                } else {
                    formGroup.controls.sessionexport.setErrors(null);
                }
            }
        }
        if (formGroup.controls.sessionfilesaftersession && formGroup.controls.filesStoringDays) {
            if (!(formGroup.controls.sessionfilesaftersession.errors && !formGroup.controls.sessionfilesaftersession.errors.noFileStoring)) {
                if (formGroup.controls.filesStoringDays.value === -1 && formGroup.controls.sessionfilesaftersession.value === true && formGroup.controls.webdav.value === false) {
                    formGroup.controls.sessionfilesaftersession.setErrors({ noFileStoring: true });
                    formGroup.controls.sessionfilesaftersession.markAsTouched();
                } else {
                    formGroup.controls.sessionfilesaftersession.setErrors(null);
                }
            }
        }
        if (formGroup.controls.offlineticket && formGroup.controls.ticket) {
            if (!(formGroup.controls.offlineticket.errors && !formGroup.controls.offlineticket.errors.noTicket)) {
                if (formGroup.controls.ticket.value === false && formGroup.controls.offlineticket.value === true) {
                    formGroup.controls.offlineticket.setErrors({ noTicket: true });
                    formGroup.controls.offlineticket.markAsTouched();
                } else {
                    formGroup.controls.offlineticket.setErrors(null);
                }
            }
        }
        if (formGroup.controls.customsessionexportsubject && formGroup.controls.sessionexport) {
            if (!(formGroup.controls.customsessionexportsubject.errors && !formGroup.controls.customsessionexportsubject.errors.noSessionExport)) {
                if (formGroup.controls.sessionexport.value === false && formGroup.controls.customsessionexportsubject.value === true) {
                    formGroup.controls.customsessionexportsubject.setErrors({ noSessionExport: true });
                    formGroup.controls.customsessionexportsubject.markAsTouched();
                } else {
                    formGroup.controls.customsessionexportsubject.setErrors(null);
                }
            }
        }
        if (formGroup.controls.mandatoryticket && formGroup.controls.ticket) {
            if (!(formGroup.controls.mandatoryticket.errors && !formGroup.controls.mandatoryticket.errors.noTicket)) {
                if (formGroup.controls.ticket.value === false && formGroup.controls.mandatoryticket.value === true) {
                    formGroup.controls.mandatoryticket.setErrors({ noTicket: true });
                    formGroup.controls.mandatoryticket.markAsTouched();
                } else {
                    formGroup.controls.mandatoryticket.setErrors(null);
                }
            }
        }
        if (formGroup.controls.roomfiles && formGroup.controls.roomfilesforsubs) {
            if (!(formGroup.controls.roomfilesforsubs.errors && !formGroup.controls.roomfilesforsubs.errors.noRoomFiles)) {
                if (formGroup.controls.roomfiles.value === false && formGroup.controls.roomfilesforsubs.value === true) {
                    formGroup.controls.roomfilesforsubs.setErrors({ noRoomFiles: true });
                    formGroup.controls.roomfilesforsubs.markAsTouched();
                } else {
                    formGroup.controls.roomfilesforsubs.setErrors(null);
                }
            }
        }
        if (formGroup.controls.twofactorauth && formGroup.controls.twofactorauthexpert) {
            if (!(formGroup.controls.twofactorauthexpert.errors && !formGroup.controls.twofactorauthexpert.errors.noTwoFactorAuth)) {
                if (formGroup.controls.twofactorauth.value === false && formGroup.controls.twofactorauthexpert.value === true) {
                    formGroup.controls.twofactorauthexpert.setErrors({ noTwoFactorAuth: true });
                    formGroup.controls.twofactorauthexpert.markAsTouched();
                } else {
                    formGroup.controls.twofactorauthexpert.setErrors(null);
                }
            }
        }
        if (formGroup.controls.sso) {
            if (!(formGroup.controls.sso.errors && !formGroup.controls.sso.errors.noSSO)) {
                if (formGroup.controls.sso.value === true) {
                    formGroup.controls.sso.setErrors({ noSSO: true });
                    formGroup.controls.sso.markAsTouched();
                } else {
                    formGroup.controls.sso.setErrors(null);
                }
            }
        }
        if (formGroup.controls.webdav) {
            if (!(formGroup.controls.webdav.errors && !formGroup.controls.webdav.errors.noWebdav)) {
                if (formGroup.controls.webdav.value === true) {
                    formGroup.controls.webdav.setErrors({ noWebdav: true });
                    formGroup.controls.webdav.markAsTouched();
                } else {
                    formGroup.controls.webdav.setErrors(null);
                }
            }
        }
        if (formGroup.controls.agreement) {
            if (!(formGroup.controls.agreement.errors && !formGroup.controls.agreement.errors.noAgreement)) {
                if (formGroup.controls.agreement.value === true) {
                    formGroup.controls.agreement.setErrors({ noAgreement: true });
                    formGroup.controls.agreement.markAsTouched();
                } else {
                    formGroup.controls.agreement.setErrors(null);
                }
            }
        }
        /*if (formGroup.controls.workflowconnections && formGroup.controls.workflowqr) {
            if (!(formGroup.controls.workflowqr.errors && !formGroup.controls.workflowqr.errors.noConnections)) {
                if (formGroup.controls.workflowconnections.value === true && formGroup.controls.workflowqr.value === true) {
                    formGroup.controls.workflowqr.setErrors({ noConnections: true });
                    formGroup.controls.workflowqr.markAsTouched();
                } else {
                    formGroup.controls.workflowqr.setErrors(null);
                }
            }
        }*/
        return null;
    }
}